export default "__VITE_ASSET__hFouoO3Y__"